import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

const [useCreateSpace, createSpace] = createAsyncAction(
  "spaces/createSpace",
  async ({ name, legacy }: { name: string; legacy?: boolean }) => {
    const endpoint = legacy ? "admin/spaces" : "spaces";
    const res = await API.call<{ space: number }>({
      endpoint,
      method: "POST",
      data: {
        name,
        legacy,
      },
    });
    return { ...res, result: res.result.space };
  }
);

export default useCreateSpace;
export { createSpace };
